import { describeCheck } from '../engines/preflightCheck';

/* ONE RENDERER FOR A PRE-FLIGHT FINDING (W-035).
   Extracted from GoLivePanel so the Go Live panel and the Admin Health Check tab cannot drift apart
   (Principle 0). Called with no options it renders exactly what GoLivePanel rendered before the
   extraction: the register's ONBOARDING fix and the offenders in their raw form.
   Options (the Health Check tab):
     live            -- read the register's LIVE fix (describeCheck(id, severity, { live: true })).
     formatOffender  -- a plain-English offender (the line by its label, the month). The raw form stays
                        in the "Technical detail" drawer. */

const MONO = "'Space Mono',monospace";

// The check CODE stays visible for us, but SECONDARY to the plain-English name.
const codeChip = {
    fontFamily: MONO, fontSize: 10, padding: '1px 5px', borderRadius: 3,
    background: 'rgba(0,0,0,0.06)', color: 'inherit', opacity: 0.75, marginLeft: 6,
};

const rawOffender = o => typeof o === 'string' ? o : JSON.stringify(o);

/* ONE renderer for a failure, blocking or warning. Reads the operator wording from the
   register; the technical `what` string stays available in the details drawer. */
export default function CheckLine({ f, tone, live = false, formatOffender = null }) {
    const d = describeCheck(f.id, f.severity, live ? { live: true } : undefined);
    const offenders = f.offenders || [];
    const show = formatOffender || rawOffender;
    return (
        <div style={{ marginTop: 8 }}>
            <div style={{ fontWeight: 700 }}>
                {d.name}
                <span style={codeChip}>{f.id}</span>
            </div>
            {d.meaning && <div style={{ marginTop: 2 }}>{d.meaning}</div>}
            {d.fix && <div style={{ marginTop: 2, opacity: 0.85 }}><em>{d.fix}</em></div>}
            {!!offenders.length && (
                <div style={{ fontFamily: MONO, fontSize: 11, color: tone, marginTop: 3 }}>
                    {offenders.length} affected:{' '}
                    {offenders.slice(0, 12).map(show).join(formatOffender ? '; ' : ', ')}
                    {offenders.length > 12 ? ` \u2026 +${offenders.length - 12} more` : ''}
                </div>
            )}
            <details style={{ marginTop: 3 }}>
                <summary style={{ cursor: 'pointer', fontSize: 11, opacity: 0.7 }}>Technical detail</summary>
                <div style={{ fontFamily: MONO, fontSize: 11, marginTop: 3, whiteSpace: 'pre-wrap' }}>{f.what}{f.why ? `\n${f.why}` : ''}{formatOffender && offenders.length ? `\n${offenders.map(rawOffender).join(', ')}` : ''}</div>
            </details>
        </div>
    );
}
